import { useState } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import { trackEvent } from "../utils/analytics";
import { scrollableTabsProps, tabsSx } from "./nascar/styles/responsive";

const RaceSeriesMenu = ({ onNascarSubMenuChange, selectedTab = "Fantasy" }) => {
  const [selectedSeries] = useState("NASCAR"); // NASCAR is the only series for now
  const selectedNascarTab = selectedTab; // owned by App, which keeps it in the URL hash

  // Handles switching between NASCAR sub-menu tabs
  const handleNascarTabChange = (event, newValue) => {
    const previousTab = selectedNascarTab;
    onNascarSubMenuChange(newValue); // Notify App.js
    
    // Track navigation between NASCAR sections
    trackEvent('nascar_section_navigation', {
      from_section: previousTab,
      to_section: newValue,
      section: 'navigation',
      label: `${previousTab} → ${newValue}`
    });
  };

  return (
    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
      {/* Top-Level Menu for Series Selection */}
      {/* <Box sx={{ position: "relative" }}>
        <Tabs value={selectedSeries} onChange={handleSeriesChange} centered>
          <Tab label="NASCAR" value="NASCAR" /> */}
      {/* <Tab label="Formula 1" value="Formula 1" />
          <Tab label="Supercars" value="Supercars" /> */}
      {/* </Tabs>
      </Box> */}

      {/* NASCAR Sub-Menu Tabs */}
      {selectedSeries === "NASCAR" && (
        <Box sx={{ mt: 1, borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={selectedNascarTab}
            onChange={handleNascarTabChange}
            {...scrollableTabsProps}
            sx={tabsSx()}
          >
            <Tab label="Fantasy" value="Fantasy" />
            <Tab label="Statistics" value="Statistics" />
            <Tab label="Favourite Driver" value="Favourite_driver" />
            <Tab label="History" value="History" />
          </Tabs>
        </Box>
      )}
    </Box>
  );
};

export default RaceSeriesMenu;
